module.exports = __webpack_public_path__ + "img/icons/nested-folder-1-digit-ac8905940660ff439a09680f2c3a4c5a.svg";